import { render } from "./UserSearch.vue?vue&type=template&id=ac5d4b46&scoped=true&ts=true"
import script from "./UserSearch.vue?vue&type=script&lang=ts"
export * from "./UserSearch.vue?vue&type=script&lang=ts"

import "./UserSearch.vue?vue&type=style&index=0&id=ac5d4b46&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac5d4b46"]])

export default __exports__